export const helper = {
    data() {
      return {
        title: 'Mixins are cool',
        copyright: 'All rights reserved. Product of super awesome people'
      };
    },
    methods: {
        isNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 45) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        loadingProgress (_container, _background = '#28C76F', _color = "#fff") {
            this.$vs.loading({
                background: _background,
                color: _color,
                container: _container,
                scale: 0.45
            })
        },
        formatNumber(value){
            let val = parseFloat(value);
            return val.toFixed(2);
        },
        getRandomNumber(){
           return Math.floor(Math.random() * (10 - 1 + 1)) + 1;
        },
        isPdf(_url){
            if (_url !== undefined) {
                let check = _url.indexOf('.pdf')
                if( check > -1){
                    return true
                }
            }
            return false
        }      
    },
    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            value = value.toLowerCase()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    }
  };